module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"tab":{"article":"檢舉/阻擋貼文","brand_user":"檢舉/阻擋作者"},"spam_type_label":"檢舉事由 (必填)","reason_placeholder":"請在{max_length}字以內輸入檢舉內容。","hint":"檢舉項目中未包含的內容請選擇其他並填寫檢舉內容。","hint2":"您檢舉的內容將在管理員審核後依照內部政策進行處理。","block_label":"是否阻擋","block_message":{"article":"阻擋該貼文。","brand_user":"阻擋該作者的所有貼文。"}}}')
  delete Component.options._Ctor
}
